import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Overlay from 'componentsV2/Hero/components/Overlay';
import HeroBackground from 'componentsV2/Hero/components/HeroBackground';
import Kicker from 'componentsV2/Hero/components/Kicker';
import ActionButtons from 'componentsV2/ActionButtons';
import Badge from 'componentsV2/Badge';
import Description from 'componentsV2/Description';
import Headline from 'componentsV2/Headline';
import Logo from 'componentsV2/Logo';
import MobileInfo from 'componentsV2/Hero/components/MobileInfo';
import Metadata from 'componentsV2/Metadata';
import ProgressBar from 'componentsV2/ProgressBar';
import { saveLiveRestart as saveGlobalLiveRestart } from 'components/VideoPlayerGlobal/Actions';
import { saveLiveVideo as saveLiveVideoAction } from 'screens/Live/LiveActions';
import { setRecommendationIdAction } from 'index/AppActions';
import useBreakpoint from 'hooks/useBreakpoint';
import { isMobileBreakpoint } from 'helpers/BreakpointHelper';
import { CollectionProcessor } from '../../processors';
import EventView from '../Event';
import style from './CollectionView.module.scss';

const Collection = ({
  analytics,
  bookmarks,
  callCollectionImpressionEvent,
  isOffset,
  item,
  saveLiveRestart,
  saveLiveVideo,
  setRecommendationId,
}) => {
  const {
    alternativeHeadline,
    backgroundProps,
    badgeProps,
    buttonArray,
    description,
    hasCountdown,
    logoProps,
    metaData,
    mobileInfoProps,
    progressProps,
    progressProps: { startDate, endDate },
    title,
  } = CollectionProcessor({
    panel: item,
    analytics,
    bookmarks,
    callCollectionImpressionEvent,
    additionalFunctions: {
      saveLiveRestart,
      saveLiveVideo,
      setRecommendationId,
    },
  });
  const [timerActive, setTimerStatus] = useState(hasCountdown);
  const isMobile = isMobileBreakpoint(useBreakpoint());
  if (timerActive) {
    return (
      <EventView
        analytics={analytics}
        callCollectionImpressionEvent={callCollectionImpressionEvent}
        item={item}
        isOffset={isOffset}
        deactivateTimer={() => {
          setTimerStatus(false);
        }}
      />
    );
  }

  return (
    <HeroBackground {...backgroundProps} theme={style} item={item}>
      <Overlay theme={style} isOffset={isOffset}>
        <Badge theme={style} {...badgeProps} />
        <Logo theme={style} {...logoProps} />
        <Kicker theme={style} alternativeHeadline={alternativeHeadline} />
        {!isMobile && <Headline theme={style} text={title} />}
        <Description theme={style} description={description} />
        {!!startDate && !!endDate ? <ProgressBar {...progressProps} theme={style} /> : null}
        <Metadata theme={style} text={metaData} />
        <MobileInfo
          badgeProps={badgeProps}
          description={description}
          item={item}
          progressProps={progressProps}
          theme={style}
          title={title}
          {...mobileInfoProps}
        />
        <ActionButtons buttons={buttonArray} theme={style} />
      </Overlay>
    </HeroBackground>
  );
};

Collection.propTypes = {
  analytics: PropTypes.shape({}),
  bookmarks: PropTypes.shape({}),
  callCollectionImpressionEvent: PropTypes.func,
  isOffset: PropTypes.bool,
  item: PropTypes.shape({}),
  saveLiveRestart: PropTypes.func.isRequired,
  saveLiveVideo: PropTypes.func.isRequired,
  setRecommendationId: PropTypes.func.isRequired,
};

export default connect(() => ({}), {
  saveLiveRestart: saveGlobalLiveRestart,
  saveLiveVideo: saveLiveVideoAction,
  setRecommendationId: setRecommendationIdAction,
})(Collection);
